import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=6ab534e6&scoped=true&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=6ab534e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab534e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab534e6')) {
      api.createRecord('6ab534e6', component.options)
    } else {
      api.reload('6ab534e6', component.options)
    }
    module.hot.accept("./FooterComponent.vue?vue&type=template&id=6ab534e6&scoped=true&", function () {
      api.rerender('6ab534e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/FooterComponent.vue"
export default component.exports